import ClaimsTab from "../pages/components/warranty/ClaimsTab";
import DevicesTab from "../pages/components/warranty/DevicesTab";
import HomeTab from "../pages/components/warranty/HomeTab";
import ProfileTab from "../pages/components/warranty/ProfileTab";


const customerRoutes = [
  { path: "", element: <HomeTab /> },        // index route
  { path: "home", element: <HomeTab /> },
  { path: "devices", element: <DevicesTab /> },
  { path: "claims", element: <ClaimsTab /> },
  { path: "profile", element: <ProfileTab /> },
];

export default customerRoutes;

